import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API_URL from '../../../utils/api';
import "../../Dashboard/View/Dashboard.css";
export default function GroupRoom() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [prompts, setPrompts] = useState([]);
  const [status, setStatus] = useState("forming");
  const [loading, setLoading] = useState(false);
  async function fetchPrompts() {
    const r = await fetch(`${API_URL}/api/sessions/${id}/prompts`);
    const data = await r.json();
    setPrompts(data);
  }
  async function startSession() {
    await fetch(`${API_URL}/api/sessions/${id}/start`, { method: "POST" });
    setStatus("live");
  }
  async function makeBreakouts() {
    setLoading(true);
    const r = await fetch(`${API_URL}/api/sessions/${id}/breakouts`, {
      method: "POST",
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify({ durationMinutes: 12 })
    });
    const pairs = await r.json();
    setLoading(false);
    if (Array.isArray(pairs) && pairs.length) {
      // just navigate the current user to the first pair for demo
      navigate(`/breakout/${pairs[0].id}`);
    }
  }
  return (
    <div className="dashboard-root">
      <div className="dashboard-main" style={{ width: "100%" }}>
        <div style={{ marginBottom: 12, color: "#666" }}>Status: {status}</div>
        <div className="dashboard-actions">
          <button className="create-session-btn" onClick={fetchPrompts}>Load Prompts</button>
          <button className="create-session-btn" onClick={startSession}>Start</button>
          <button className="join-session-btn" onClick={makeBreakouts} disabled={loading}>
            {loading ? "Pairing..." : "Create Breakouts"}
          </button>
        </div>
        <div className="dashboard-sessions">
          <div className="session-card" style={{ gridColumn: "1 / -1" }}>
            <h3>I-Sharing Prompts</h3>
            <ul>
              {prompts.map(p => <li key={p.id}>{p.text}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
